export enum EmploymentStatus {
  EMPLOYED = 'EMPLOYED',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  UNEMPLOYED = 'UNEMPLOYED',
  RETIRED = 'RETIRED',
  HOUSEPERSON = 'HOUSEPERSON',
  DISABILITY = 'DISABILITY',
  EDUCATION = 'EDUCATION',
}

export enum MedicalCondition {
  DVLA_AWARE_NO_RESTRICTIONS = 'DVLA_AWARE_NO_RESTRICTIONS',
  DVLA_AWARE_1_YEAR_RESTRICTION = 'DVLA_AWARE_1_YEAR_RESTRICTION',
  DVLA_AWARE_2_YEAR_RESTRICTION = 'DVLA_AWARE_2_YEAR_RESTRICTION',
  DVLA_AWARE_3_YEAR_RESTRICTION = 'DVLA_AWARE_3_YEAR_RESTRICTION',
  DVLA_AWARE_5_YEAR_RESTRICTION = 'DVLA_AWARE_5_YEAR_RESTRICTION',
  ADVISED_NO_DRIVE = 'ADVISED_NO_DRIVE',
  DVLA_UNAWARE = 'DVLA_UNAWARE',
  NONE = 'NONE',
}
